module.exports = __webpack_public_path__ + "static/media/dcs005.0e257d18.png";